import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Overzichten, {
  isVisible: () => true,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.Overzichten,
    title: 'Overzichten',
    url: '/content/rapportage/',
    iconclass: 'far fa-list',
  }),
});
